module.exports = __webpack_public_path__ + "assets/aa23b7b4bcf2b8f0e876106bb3de69c6.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-400-normal.woff2
// module id = 2635
// module chunks = 121